// Reveal on scroll
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('in');
      observer.unobserve(entry.target);
    }
  });
}, { rootMargin: '0px 0px -80px 0px' });

document.querySelectorAll('.reveal, .chapter').forEach((el) => observer.observe(el));

// Hero masked line reveal on load
requestAnimationFrame(() => document.body.classList.add('in-hero'));

// Nav background on scroll
const nav = document.getElementById('nav');
const onScroll = () => nav && nav.classList.toggle('scrolled', window.scrollY > 40);
window.addEventListener('scroll', onScroll, { passive: true });
onScroll();

// Book 3D tilt on mouse
const stage = document.getElementById('book-stage');
if (stage) {
  const tilts = stage.querySelectorAll('[data-tilt]');
  stage.addEventListener('mousemove', (e) => {
    const r = stage.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    tilts.forEach((el) => {
      const base = el.classList.contains('tilt-front')
        ? 'translateX(70px)'
        : 'translateX(-95px) translateY(18px) scale(0.92)';
      el.style.transform = `${base} rotateY(${x * 10}deg) rotateX(${y * -7}deg)`;
    });
  });
  stage.addEventListener('mouseleave', () => {
    tilts.forEach((el) => { el.style.transform = ''; });
  });
}

// Smooth anchor scrolling
document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach((a) => {
  a.addEventListener('click', (e) => {
    const id = a.getAttribute('href').replace('/', '');
    const target = document.querySelector(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});
